import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails6 = () => {
  const uMaxPowerData = {
    title: "Utpann U-max Power",
    category: "Mycorrhizal Bio-fertilizer",
    image: "/assets/Product/img6.png",
    description:
      "UTPANN U-Max Power is a powerful root growth enhancer that promotes strong and deeper root development. It improves nutrient and water absorption, helping plants establish quickly and grow vigorously. Ideal for all crops, U-Max Power builds a strong foundation for healthier plants and higher yields.",
    price: "900",
    priceNote: "Per 4kg Pack (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Strong Root Development", "Better Uptake"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      {
        label: "Total viable spore/gram of product",
        value: "min. 10 viable spore",
      },
      { label: "pH", value: "6.0-8.4" },
      { label: "Electrical Conductivity", value: "Not more than 4.0" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "2kg / 4kg / 30kg" },
      { label: "Container", value: "20ft & 40ft available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Stimulates strong, deep, and healthy root development",
      "Improves nutrient and water absorption efficiency",
      "Enhances early crop establishment and plant vigor",
      "Increases stress tolerance, leading to better yield potential",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={uMaxPowerData} />

        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails6;
